<template>
  <!-- HEADER -->
  <div class="w-full flex flex-col px-2 pb-2">
    <div class="w-full flex justify-around items-center p-1 border-b-2">
      <div class="w-full flex justify-center">
        <span class="font-bold text-primary text-sm md:text-xl p-1">
          {{ cartProduct.code }} - {{ productLang.name }}
        </span>
      </div>

      <div v-if="isInCart(cartProduct.id)" @click.stop="removeItemFromCart"
           class="border border-danger hover:bg-danger p-2 text-secondary bg-grey-light rounded-lg flex flex-grow items-center justify-center cursor-pointer">
        <feather-icon icon="Trash2Icon" svgClasses="h-4 w-4" />
      </div>
    </div>

    <div class="w-full flex flex-row pt-1">
      <!-- Product data and options -->
      <div class="w-1/2 flex flex-col md:flex-row">
        <div class="w-full flex justify-center">
          <img :src="cartProduct.image" :alt="productLang.name" class="w-auto max-w-32 xl:max-w-48 h-auto max-h-32 xl:max-h-48 p-0 md:p-4">
        </div>

        <!-- Quantity option -->
        <div class="w-full flex flex-col items-center md:items-start justify-center pt-2" v-if="hasQuantity">
          <p class="font-bold text-sm">{{ $t('pages.shop.checkout.tab1.productQtd') }}</p>
          <vs-input-number :min="1" :max="maxQuantity" color="#76bb46" v-model="quantity" class="inline-flex"/>
        </div>
      </div>

      <!--  PRICE  -->
      <div class="w-1/2 flex items-center border-l border-primary">
        <div class="w-full flex flex-col p-2">
          <div class="my-4">
            <!-- Unitary price -->
            <div class="flex justify-between mb-1">
              <p class="text-primary">{{ $t('pages.shop.checkout.tab1.serviceBox.headerPlanningPrice') }}</p>

              <h5 class="text-center text-primary">
                <span v-if="$store.state.Profile.isBRL()"> {{ getPlanningServicePrice | BRL }} </span>
                <span v-if="$store.state.Profile.isUSD()"> {{ getPlanningServicePrice | USD }} </span>
              </h5>
            </div>

            <!-- Combo discounts -->
            <div class="flex justify-between mb-1" v-if="cartProduct.discount > 0">
              <p class="text-sm text-danger"> {{ $t('pages.shop.checkout.tab1.serviceBox.comboDiscount') }} </p>

              <h5 class="text-center text-sm text-danger" v-if="$store.state.Profile.isBRL()">
                ({{ cartProduct.discount }}%) - {{ getComboDiscount | BRL }}
              </h5>
              <h5 class="text-center text-sm text-danger" v-else>
                ({{ cartProduct.discount }}%) - {{ getComboDiscount | USD }}
              </h5>
            </div>

            <!-- Manufacture -->
            <div class="flex justify-between mb-1">
              <p class="text-primary"> {{ $t('pages.shop.checkout.tab1.serviceBox.headerManufacturePrice') }} </p>

              <h5 class="font-bold text-primary">
                <span class="text-primary text-center text-sm" v-if="$store.state.Profile.isBRL()"> {{ getManufactureServicePrice | BRL }} </span>
                <span class="text-primary text-center text-sm" v-else>{{ getManufactureServicePrice | USD }}</span>
              </h5>
            </div>

            <vs-divider class="m-0"/>

            <div class="flex justify-between mt-1">
              <p class="font-bold text-secondary"> {{ $t('pages.shop.checkout.tab1.total') }} </p>
              <h5 class="font-bold text-center text-secondary" v-if="$store.state.Profile.isBRL()">{{ getTotal | BRL }}</h5>
              <h5 class="font-bold text-center text-secondary" v-else>{{ getTotal | USD }}</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Product} from "@/models/Product.model";

export default {
  name: "CheckoutHeaderProduct",
  props: {
    cartProduct: {
      type: Product,
      required: true
    }
  },
  data() {
    return {

    }
  },
  computed: {
    productLang() {
      const locale = this.$i18n.locale;
      return this.cartProduct[locale];
    },
    isInCart() {
      return (itemId) => this.$store.getters['Shop/isInCart'](itemId);
    },

    getPlanningServicePrice() {
      const planning_price = this.$store.getters['Shop/getServicePlanningPriceByCartItemId'](this.cartProduct.id);
      return planning_price;
    },
    getManufactureServicePrice() {
      const manufacture_price = this.$store.getters['Shop/getServiceManufacturePriceByCartItemId'](this.cartProduct.id);
      return manufacture_price;
    },
    getComboDiscount() {
      const combo_discount = this.$store.getters['Shop/getComboDiscountByCartItemId'](this.cartProduct.id);
      return combo_discount;
    },
    getTotal() {
      const total = this.$store.getters['Shop/getTotalByCartItemId'](this.cartProduct.id);
      return total;
    },

    hasQuantity() {
      return !this.cartProduct.perCase();
    },
    maxQuantity() {
      return this.cartProduct.getAllowedQtd();
    },
    quantity: {
      get() {
        return this.cartProduct.quantity;
      },
      set(val) {
        this.$store.dispatch('Shop/setProductQuantity', { productId: this.cartProduct.id, quantity: Number(val) });
      }
    }
  },
  methods: {
    removeItemFromCart() {
      this.$store.dispatch('Shop/toggleItemInCart', this.cartProduct.id);
    },
  }
}
</script>

<style scoped>

</style>
